module.exports = ".rowPrecio {\n  height: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: rgba(0, 0, 0, 0.12);\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/compania/configuracion/compania-configuracion.component.scss
// module id = ./src/app/compania/configuracion/compania-configuracion.component.scss
// module chunks = main